"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        var globalFilterPane;
        (function (globalFilterPane) {
            class GlobalFilterPaneInitArgs {
            }
            const PANE_SELECTOR = '#dashboard-global-filter-pane';
            const TOGGLE_SELECTOR = '#dashboard-global-filter-toggle';
            const BAR_SELECTOR = '#dashboard-global-filter-bar';
            const BAR_HEIGHT_PX = 48;
            const BODY_SELECTOR = '.dashboard-global-filter-body';
            const EMPTY_VALUE = '';
            const PANE_WIDTH_PX = 286;
            const WIDGET_CARD_PADDING_PX = 8;
            const DATE_PRESET_ALL = 'All';
            const DATE_PRESET_CUSTOM = 'CustomRange';
            const INFERABLE_DATE_PRESETS = ['Today', 'Last7Days', 'ThisMonth', 'LastMonth', 'Last6Months', 'Last12Months'];
            const escapePipe = (value) => value.replace(/%/g, '%25').replace(/\|/g, '%7C');
            const unescapePipe = (value) => value.replace(/%7C/gi, '|').replace(/%25/g, '%');
            let _filters = [];
            let _fetchGlobalFilterOptions;
            let _appliedParams = new URLSearchParams();
            let _lastCommittedParams = '';
            let _squeezed = [];
            let _paneCloseTimer = null;
            const PANE_ANIMATION_MS = 300;
            function selectionsKey(filter) {
                return `globalFilter:${filter.id}`;
            }
            function getSelections(filter) {
                return distill.dashboards.filterOptionsStore.getSelections(selectionsKey(filter));
            }
            function paramSuffixes(filter) {
                return filter.type === distill.dashboards.DashboardGlobalFilterType.DateRange || filter.type === distill.dashboards.DashboardGlobalFilterType.NumberRange
                    ? ['_gte', '_lte']
                    : [''];
            }
            function filterDataName(filter) {
                const explicitName = (filter.dataName || '').trim();
                if (explicitName)
                    return explicitName;
                const name = (filter.label || '')
                    .replace(/[^a-zA-Z0-9 ]/g, '')
                    .split(' ')
                    .filter(w => !!w)
                    .map((w, i) => i === 0 ? w.toLowerCase() : (w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()))
                    .join('');
                return name || filter.id;
            }
            function readUrlParams() {
                const url = new URLSearchParams(window.location.search);
                const state = new URLSearchParams();
                _filters.forEach(filter => {
                    const name = filterDataName(filter);
                    paramSuffixes(filter).forEach(suffix => {
                        const value = url.get(`${name}${suffix}`);
                        if (value !== null)
                            state.set(`${filter.id}${suffix}`, value);
                    });
                });
                return state;
            }
            function writeUrlParams() {
                const url = new URLSearchParams(window.location.search);
                _filters.forEach(filter => {
                    const name = filterDataName(filter);
                    paramSuffixes(filter).forEach(suffix => {
                        url.delete(`${name}${suffix}`);
                        const key = `${filter.id}${suffix}`;
                        if (_appliedParams.has(key)) {
                            const value = _appliedParams.get(key) || '';
                            url.set(`${name}${suffix}`, value);
                        }
                    });
                });
                const query = url.toString();
                history.replaceState(null, '', query ? `${window.location.pathname}?${query}` : window.location.pathname);
            }
            function init(args) {
                _filters = (args.design && args.design.globalFilters) ? args.design.globalFilters : [];
                _fetchGlobalFilterOptions = args.fetchGlobalFilterOptions;
                const $pane = $(PANE_SELECTOR);
                const $toggle = $(TOGGLE_SELECTOR);
                if (!$pane.length)
                    return;
                if (_filters.length === 0) {
                    $pane.addClass('d-none');
                    $toggle.addClass('d-none');
                    return;
                }
                $toggle.removeClass('d-none');
                _appliedParams = readUrlParams();
                _lastCommittedParams = _appliedParams.toString();
                buildControls($pane.find(BODY_SELECTOR));
                bindEvents($pane, $toggle);
                if (_appliedParams.toString() !== '')
                    openPane($pane, $toggle);
                updateToggleState();
                positionToggle();
            }
            globalFilterPane.init = init;
            function getAppliedGlobalFilterValues() {
                const values = {};
                _appliedParams.forEach((value, key) => values[key] = value);
                return values;
            }
            globalFilterPane.getAppliedGlobalFilterValues = getAppliedGlobalFilterValues;
            function getAppliedFilters() {
                const values = getAppliedGlobalFilterValues();
                const filters = [];
                _filters.forEach(filter => {
                    switch (filter.type) {
                        case distill.dashboards.DashboardGlobalFilterType.Text: {
                            const value = values[filter.id];
                            if (value)
                                filters.push({ filterId: filter.id, values: [value] });
                            break;
                        }
                        case distill.dashboards.DashboardGlobalFilterType.Dropdown: {
                            if (values[filter.id] !== undefined)
                                filters.push({ filterId: filter.id, values: values[filter.id].split('|').map(unescapePipe) });
                            break;
                        }
                        case distill.dashboards.DashboardGlobalFilterType.DateRange:
                        case distill.dashboards.DashboardGlobalFilterType.NumberRange: {
                            const from = values[`${filter.id}_gte`];
                            const to = values[`${filter.id}_lte`];
                            if (from || to)
                                filters.push({ filterId: filter.id, from: from || '', to: to || '' });
                            break;
                        }
                    }
                });
                return filters;
            }
            globalFilterPane.getAppliedFilters = getAppliedFilters;
            function bindEvents($pane, $toggle) {
                $toggle.on('click', (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    togglePane($pane, $toggle);
                });
                $(window).on('resize.dashboard-global-filter', () => {
                    positionToggle();
                    if (!$pane.hasClass('d-none') && !$pane.hasClass('pane-off-canvas')) {
                        positionPane($pane, $toggle);
                        updatePaneSqueeze($pane);
                    }
                });
                $pane.find('.dashboard-global-filter-apply').on('click', () => applyFilters());
                $pane.find('.dashboard-global-filter-reset').on('click', (e) => {
                    e.preventDefault();
                    resetFilters();
                });
                $pane.on('change input', 'input, select', () => updateApplyState());
                updateApplyState();
            }
            function togglePane($pane, $toggle) {
                if ($pane.hasClass('d-none') || $pane.hasClass('pane-off-canvas'))
                    openPane($pane, $toggle);
                else
                    closePane($pane);
                updateToggleState();
            }
            function updateToggleState() {
                const $toggle = $(TOGGLE_SELECTOR);
                if (!$toggle.length)
                    return;
                const $pane = $(PANE_SELECTOR);
                const expanded = !$pane.hasClass('d-none') && !$pane.hasClass('pane-off-canvas');
                const active = Object.values(getAppliedGlobalFilterValues()).some(v => v !== EMPTY_VALUE);
                $toggle.toggleClass('btn-primary', expanded && active);
                $toggle.toggleClass('btn-outline-primary', !expanded && active);
                $toggle.toggleClass('btn-secondary', expanded && !active);
                $toggle.toggleClass('btn-outline-secondary', !expanded && !active);
            }
            function openPane($pane, $toggle) {
                if (_paneCloseTimer !== null)
                    window.clearTimeout(_paneCloseTimer);
                _paneCloseTimer = null;
                $pane.addClass('pane-off-canvas');
                $pane.removeClass('d-none');
                positionPane($pane, $toggle);
                updatePaneSqueeze($pane);
                void $pane[0].offsetWidth;
                $pane.removeClass('pane-off-canvas');
                appn.select.initForDesign({
                    elements: $pane.find(BODY_SELECTOR).find('select'),
                    minimumResultsForSearch: '10'
                });
            }
            function closePane($pane) {
                if (_paneCloseTimer !== null)
                    window.clearTimeout(_paneCloseTimer);
                $pane.addClass('pane-off-canvas');
                clearPaneSqueeze();
                _paneCloseTimer = window.setTimeout(() => {
                    _paneCloseTimer = null;
                    $pane.addClass('d-none');
                }, PANE_ANIMATION_MS);
            }
            function positionToggle() {
                const $toggle = $(TOGGLE_SELECTOR);
                const $bar = $(BAR_SELECTOR);
                if (!$toggle.length || !$bar.length)
                    return;
                const $titlebar = $('.component.titleBar').first();
                if ($titlebar.length) {
                    $bar.addClass('d-none');
                    if ($toggle.parent()[0] !== $titlebar[0])
                        $titlebar.append($toggle);
                    $toggle.css({ position: '', top: '', left: '', right: '' });
                    return;
                }
                $bar.removeClass('d-none').height(BAR_HEIGHT_PX);
                if ($toggle.parent()[0] !== $bar[0])
                    $bar.append($toggle);
                $toggle.css({ position: '', top: '', left: '', right: '' });
            }
            function positionPane($pane, $toggle) {
                const $content = $('#content.dash-view');
                const $titlebar = $('.component.titleBar').filter(':visible').first();
                const topAnchor = $titlebar.length ? $titlebar : $toggle;
                const topAnchorOffset = topAnchor.length ? topAnchor.offset() : null;
                const toggleOffset = $toggle.offset();
                const contentOffset = $content.length ? $content.offset() : null;
                if (!topAnchorOffset || !toggleOffset || !contentOffset)
                    return;
                const rightInset = Math.max(8, contentOffset.left + ($content.outerWidth() || 0)
                    - (toggleOffset.left + ($toggle.outerWidth() || 0)));
                $pane.css({
                    top: topAnchorOffset.top + (topAnchor.outerHeight() || 0) - contentOffset.top + 9,
                    right: rightInset
                });
            }
            function updatePaneSqueeze($pane) {
                clearPaneSqueeze();
                const paneEl = $pane[0];
                const $content = $('#content.dash-view');
                if (!paneEl || !$content.length)
                    return;
                const rightInset = parseFloat($pane.css('right')) || 0;
                const reserve = PANE_WIDTH_PX + rightInset - WIDGET_CARD_PADDING_PX;
                const contentRect = $content[0].getBoundingClientRect();
                const paneWidth = paneEl.offsetWidth || PANE_WIDTH_PX;
                const paneTop = contentRect.top + (parseFloat($pane.css('top')) || 0);
                const paneBottom = paneTop + paneEl.offsetHeight;
                const paneLeft = contentRect.right - rightInset - paneWidth;
                const widgets = $('.grid-stack > .component').not('.titleBar').toArray();
                const overlapsPane = (el) => {
                    const $el = $(el);
                    const rect = el.getBoundingClientRect();
                    if (rect.bottom <= paneTop || rect.top >= paneBottom)
                        return false;
                    const grid = el.closest('.grid-stack');
                    const gridWidth = grid ? grid.clientWidth : contentRect.width;
                    const xFrac = (Number($el.attr('gs-x')) || 0) / 12;
                    const wFrac = (Number($el.attr('gs-w')) || 1) / 12;
                    const rightEdge = (grid ? grid.getBoundingClientRect().left : contentRect.left) + (xFrac + wFrac) * gridWidth;
                    return rightEdge > paneLeft;
                };
                if (!widgets.some(overlapsPane))
                    return;
                widgets.forEach(el => {
                    const $el = $(el);
                    const xFrac = (Number($el.attr('gs-x')) || 0) / 12;
                    const wFrac = (Number($el.attr('gs-w')) || 1) / 12;
                    $el.css({
                        left: `calc((100% - ${reserve}px) * ${xFrac})`,
                        width: `calc((100% - ${reserve}px) * ${wFrac})`
                    });
                    _squeezed.push(el);
                });
            }
            function clearPaneSqueeze() {
                _squeezed.forEach(el => $(el).css({ left: '', width: '' }));
                _squeezed = [];
            }
            function buildControls($body) {
                $body.empty();
                if (!$body.length)
                    return;
                const params = _appliedParams;
                _filters.forEach(filter => $body.append(buildFilterControl(filter, params)));
                $body.append(appn.utils.cloneTemplate('global-filter-apply-row'));
                appn.ui.datePicker($body.find('.datepicker'), () => updateApplyState(), 'YYYY-MM-DD');
                _filters.forEach(filter => {
                    if (filter.type !== distill.dashboards.DashboardGlobalFilterType.Dropdown)
                        return;
                    populateDropdown($body.find(`.dashboard-global-filter-item[data-filter-id="${filter.id}"]`), filter);
                });
            }
            function buildFilterControl(filter, params) {
                const $item = appn.utils.cloneTemplate('global-filter-control')
                    .attr('data-filter-id', filter.id)
                    .attr('data-filter-type', filter.type);
                $item.find('.dashboard-global-filter-item-label').text(filter.label || '');
                switch (filter.type) {
                    case distill.dashboards.DashboardGlobalFilterType.DateRange: {
                        const $section = $item.find('.dashboard-global-filter-date-section').removeClass('d-none');
                        const $preset = $section.find('.dashboard-global-filter-date-preset');
                        getDatePresetOptions().forEach(preset => $preset.append($('<option>').val(preset.value).text(preset.label)));
                        const fromValue = params.get(`${filter.id}_gte`) || EMPTY_VALUE;
                        const toValue = params.get(`${filter.id}_lte`) || EMPTY_VALUE;
                        const inferredPreset = inferDatePreset(fromValue, toValue);
                        $preset.val(inferredPreset);
                        const $custom = $section.find('.dashboard-global-filter-custom-dates');
                        $custom.find('.dashboard-global-filter-from').val(fromValue);
                        $custom.find('.dashboard-global-filter-to').val(toValue);
                        $custom.toggleClass('d-none', inferredPreset !== DATE_PRESET_CUSTOM);
                        $preset.on('change', () => {
                            $custom.toggleClass('d-none', $preset.val() !== DATE_PRESET_CUSTOM);
                            const $pane = $(PANE_SELECTOR);
                            positionPane($pane, $(TOGGLE_SELECTOR));
                            updatePaneSqueeze($pane);
                        });
                        break;
                    }
                    case distill.dashboards.DashboardGlobalFilterType.Dropdown:
                        $item.find('.dashboard-global-filter-dropdown-section').removeClass('d-none');
                        break;
                    case distill.dashboards.DashboardGlobalFilterType.NumberRange: {
                        const $section = $item.find('.dashboard-global-filter-number-section').removeClass('d-none');
                        $section.find('.dashboard-global-filter-number-from').val(params.get(`${filter.id}_gte`) || EMPTY_VALUE);
                        $section.find('.dashboard-global-filter-number-to').val(params.get(`${filter.id}_lte`) || EMPTY_VALUE);
                        break;
                    }
                    default:
                        $item.find('.dashboard-global-filter-text-section').removeClass('d-none')
                            .find('.dashboard-global-filter-text').val(params.get(filter.id) || EMPTY_VALUE);
                }
                return $item;
            }
            function populateDropdown($item, filter) {
                const $values = $item.find('.dashboard-global-filter-values');
                const $search = $item.find('.dashboard-global-filter-dropdown-search');
                const $searchClear = $item.find('.dashboard-global-filter-search-clear');
                const $selectAll = $item.find('.dashboard-global-filter-select-all');
                const $limited = $item.find('.dashboard-global-filter-limited');
                if (!$values.length)
                    return;
                let searchToken = 0;
                let hasBlanks = false;
                $search.val('');
                $searchClear.toggle(false);
                if (!distill.dashboards.filterOptionsStore.hasSelections(selectionsKey(filter))) {
                    const applied = _appliedParams.has(filter.id) ? (_appliedParams.get(filter.id) || '').split('|').map(unescapePipe) : [];
                    distill.dashboards.filterOptionsStore.seedSelections(selectionsKey(filter), applied);
                }
                const renderOptions = (options, search) => {
                    const selections = getSelections(filter);
                    const blankOption = options.find(o => o.value === '') || null;
                    const valueOptions = options.filter(o => o.value !== '');
                    valueOptions.forEach(o => {
                        if (selections.has(o.value))
                            selections.set(o.value, { display: o.display || o.value, count: 0 });
                    });
                    $values.empty();
                    if (search === '')
                        hasBlanks = blankOption !== null;
                    if (hasBlanks || selections.has(''))
                        $values.append(buildDropdownValueOption('', '', selections.has('')));
                    if (search === '') {
                        const known = new Set(valueOptions.map(o => o.value));
                        selections.forEach((prior, value) => {
                            if (!known.has(value) && value !== '')
                                $values.append(buildDropdownValueOption(value, prior.display, true));
                        });
                    }
                    valueOptions.forEach(o => {
                        $values.append(buildDropdownValueOption(o.value, o.display || o.value, selections.has(o.value)));
                    });
                    $limited.toggleClass('d-none', valueOptions.length < distill.dashboards.FILTER_OPTIONS_LIMIT);
                    syncDropdownSelectAll($item);
                };
                const loadOptions = (search) => {
                    const token = ++searchToken;
                    const cacheKey = selectionsKey(filter);
                    const cached = distill.dashboards.filterOptionsStore.getCached(cacheKey, search);
                    if (cached !== null) {
                        if (token !== searchToken)
                            return;
                        renderOptions(cached, search);
                        return;
                    }
                    _fetchGlobalFilterOptions(filter, search).then(options => {
                        if (token !== searchToken || !$values.length)
                            return;
                        if (search === '')
                            distill.dashboards.filterOptionsStore.setCached(cacheKey, options);
                        renderOptions(options, search);
                    });
                };
                $search.off('input').on('input', () => {
                    const term = ($search.val() || '').trim();
                    $searchClear.toggle(term.length > 0);
                    window.clearTimeout($search.data('searchTimer'));
                    $search.data('searchTimer', window.setTimeout(() => loadOptions(term), 300));
                });
                $searchClear.off('click').on('click', () => {
                    $search.val('').trigger('input').trigger('focus');
                });
                const syncSelections = () => {
                    const selections = getSelections(filter);
                    $values.find('.dashboard-global-filter-value').each((_, el) => {
                        const $cb = $(el).find('input');
                        const value = String($cb.val());
                        if ($cb.prop('checked')) {
                            selections.set(value, {
                                display: $(el).find('.dashboard-global-filter-value-label').text(),
                                count: 0
                            });
                        }
                        else
                            selections.delete(value);
                    });
                    syncDropdownSelectAll($item);
                };
                $selectAll.off('change').on('change', 'input', e => {
                    const checked = $(e.target).prop('checked');
                    $values.children().find('input').prop('checked', checked);
                    syncSelections();
                });
                $values.off('change').on('change', 'input', syncSelections);
                loadOptions('');
            }
            function buildDropdownValueOption(value, display, isChecked) {
                const label = value === '' ? T('(blank)') : (display || value);
                return $('<label class="dashboard-global-filter-value"></label>')
                    .append($('<input type="checkbox" class="dashboard-global-filter-value-cb" />').val(value).prop('checked', isChecked))
                    .append($('<span class="dashboard-global-filter-value-label"></span>').text(label));
            }
            function syncDropdownSelectAll($item) {
                const $checks = $item.find('.dashboard-global-filter-value input');
                const total = $checks.length;
                const checked = $checks.filter(':checked').length;
                $item.find('.dashboard-global-filter-select-all-cb').prop('checked', total > 0 && checked === total).prop('indeterminate', checked > 0 && checked < total);
            }
            function applyFilters() {
                commitFilters(collectFilterParams());
                updateApplyState();
                updateToggleState();
            }
            function collectFilterParams() {
                const params = new URLSearchParams();
                const $body = $(PANE_SELECTOR).find(BODY_SELECTOR);
                _filters.forEach(filter => {
                    const $item = $body.find(`.dashboard-global-filter-item[data-filter-id="${filter.id}"]`);
                    switch (filter.type) {
                        case distill.dashboards.DashboardGlobalFilterType.DateRange: {
                            const preset = $item.find('.dashboard-global-filter-date-preset').val() || 'All';
                            let from = EMPTY_VALUE;
                            let to = EMPTY_VALUE;
                            if (preset === 'CustomRange') {
                                from = ($item.find('.dashboard-global-filter-from').val() || '').trim();
                                to = ($item.find('.dashboard-global-filter-to').val() || '').trim();
                            }
                            else {
                                const range = resolveDatePreset(preset);
                                from = range.from || EMPTY_VALUE;
                                to = range.to || EMPTY_VALUE;
                            }
                            params.set(`${filter.id}_gte`, from);
                            params.set(`${filter.id}_lte`, to);
                            break;
                        }
                        case distill.dashboards.DashboardGlobalFilterType.NumberRange: {
                            const from = ($item.find('.dashboard-global-filter-number-from').val() || '').trim();
                            const to = ($item.find('.dashboard-global-filter-number-to').val() || '').trim();
                            params.set(`${filter.id}_gte`, from);
                            params.set(`${filter.id}_lte`, to);
                            break;
                        }
                        case distill.dashboards.DashboardGlobalFilterType.Dropdown: {
                            const selections = getSelections(filter);
                            if (selections.size > 0)
                                params.set(filter.id, Array.from(selections.keys()).map(escapePipe).join('|'));
                            break;
                        }
                        default: {
                            const value = ($item.find('.dashboard-global-filter-text').val() || '');
                            params.set(filter.id, value);
                            break;
                        }
                    }
                });
                return params;
            }
            function resetFilters() {
                const $body = $(PANE_SELECTOR).find(BODY_SELECTOR);
                $body.find('.dashboard-global-filter-text, .dashboard-global-filter-from, .dashboard-global-filter-to, .dashboard-global-filter-number-from, .dashboard-global-filter-number-to, .dashboard-global-filter-dropdown-search').val('');
                $body.find('.dashboard-global-filter-value-cb').prop('checked', false);
                $body.find('.dashboard-global-filter-select-all-cb').prop('checked', false).prop('indeterminate', false);
                $body.find('.dashboard-global-filter-date-preset').val(DATE_PRESET_ALL);
                $body.find('.dashboard-global-filter-custom-dates').addClass('d-none');
                _filters.forEach(filter => distill.dashboards.filterOptionsStore.deleteSelections(selectionsKey(filter)));
                $body.find('select').trigger('change');
                commitFilters(collectFilterParams());
                updateApplyState();
                updateToggleState();
            }
            function resolveApplied(params) {
                const cleaned = new URLSearchParams();
                params.forEach((value, key) => {
                    const isDropdownKey = _filters.some(f => f.id === key && f.type === distill.dashboards.DashboardGlobalFilterType.Dropdown);
                    if (value !== EMPTY_VALUE || isDropdownKey)
                        cleaned.set(key, value);
                });
                return cleaned;
            }
            function updateApplyState() {
                const $apply = $(PANE_SELECTOR).find('.dashboard-global-filter-apply');
                if (!$apply.length)
                    return;
                const dirty = resolveApplied(collectFilterParams()).toString() !== _lastCommittedParams;
                $apply.toggleClass('btn-primary', dirty);
                $apply.toggleClass('btn-outline-secondary', !dirty);
            }
            function commitFilters(params) {
                const cleaned = resolveApplied(params);
                const state = cleaned.toString();
                if (state === _lastCommittedParams)
                    return;
                _lastCommittedParams = state;
                _appliedParams = cleaned;
                writeUrlParams();
                distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, { resetTablePaging: true });
            }
            function inferDatePreset(fromValue, toValue) {
                if (fromValue === EMPTY_VALUE && toValue === EMPTY_VALUE)
                    return DATE_PRESET_ALL;
                for (const preset of INFERABLE_DATE_PRESETS) {
                    const range = resolveDatePreset(preset);
                    if ((range.from || EMPTY_VALUE) === fromValue && (range.to || EMPTY_VALUE) === toValue)
                        return preset;
                }
                return DATE_PRESET_CUSTOM;
            }
            function resolveDatePreset(preset) {
                const now = new Date();
                const fmt = (utcMs) => {
                    const d = new Date(utcMs);
                    return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
                };
                const DAY_MS = 24 * 60 * 60 * 1000;
                const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
                switch (preset) {
                    case 'Today':
                        return { from: fmt(today), to: fmt(today) };
                    case 'Last7Days':
                        return { from: fmt(today - 7 * DAY_MS), to: fmt(today) };
                    case 'ThisMonth':
                        return { from: fmt(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)), to: fmt(today) };
                    case 'LastMonth':
                        return { from: fmt(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1)), to: fmt(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0)) };
                    case 'Last6Months':
                        return { from: fmt(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 5, 1)), to: fmt(today) };
                    case 'Last12Months':
                        return { from: fmt(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 11, 1)), to: fmt(today) };
                    default:
                        return { from: null, to: null };
                }
            }
            function getDatePresetOptions() {
                return [
                    { value: 'All', label: T('All') },
                    { value: 'Today', label: T('Today') },
                    { value: 'Last7Days', label: T('Last 7 Days') },
                    { value: 'ThisMonth', label: T('This Month') },
                    { value: 'LastMonth', label: T('Last Month') },
                    { value: 'Last6Months', label: T('Last 6 Months') },
                    { value: 'Last12Months', label: T('Last 12 Months') },
                    { value: 'CustomRange', label: T('Custom Range') }
                ];
            }
            function pad2(value) {
                return value < 10 ? `0${value}` : value.toString();
            }
        })(globalFilterPane = dashboards.globalFilterPane || (dashboards.globalFilterPane = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
